import { Box, Grid, Stack, Typography } from "@mui/material";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";

const tryParseJson = (value) => {
  if (typeof value !== "string") return value;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const getOverlayState = (data) => {
  if (!data || typeof data !== "object" || Array.isArray(data)) return null;

  const overlay =
    data.alerts?.showProfileCompletionOverlay &&
    typeof data.alerts.showProfileCompletionOverlay === "object"
      ? data.alerts.showProfileCompletionOverlay
      : data.showProfileCompletionOverlay &&
          typeof data.showProfileCompletionOverlay === "object"
        ? data.showProfileCompletionOverlay
        : data;

  if (
    typeof overlay.showProfileCompletionOverlay !== "boolean" &&
    typeof overlay.overlayType !== "string"
  ) {
    return null;
  }

  return {
    enabled: Boolean(overlay.showProfileCompletionOverlay),
    overlayType: overlay.overlayType === "forced" ? "forced" : "simple",
  };
};

export default function ShowProfileCompletionOverlaySettings({ rawData }) {
  const overlayState = getOverlayState(tryParseJson(rawData));

  if (!overlayState) {
    return (
      <Typography color="error" variant="body2" sx={{ p: 2 }}>
        Invalid or empty Profile Completion Overlay settings JSON
      </Typography>
    );
  }

  const { enabled, overlayType } = overlayState;

  return (
    <Stack spacing={1} sx={{ p: 0, flex: 1, justifyContent: "center" }}>
      <Grid container spacing={1}>
        <Grid item xs={6}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 0.5,
                mb: 0.5,
              }}
            >
              <AccountCircleOutlinedIcon
                sx={{
                  fontSize: "1rem",
                  color: enabled ? "success.main" : "text.disabled",
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  color: "text.secondary",
                  fontSize: "0.7rem",
                  fontWeight: 600,
                  textTransform: "uppercase",
                  letterSpacing: 0.5,
                }}
              >
                Status
              </Typography>
            </Box>
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                color: enabled ? "success.dark" : "text.secondary",
                fontSize: "0.8rem",
                textTransform: "uppercase",
              }}
            >
              {enabled ? "Enabled" : "Disabled"}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: "text.secondary",
                fontSize: "0.7rem",
                fontWeight: 600,
                textTransform: "uppercase",
                letterSpacing: 0.5,
                mb: 0.5,
              }}
            >
              Overlay Type
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                fontWeight: 700,
                color: "text.primary",
                fontSize: "0.8rem",
              }}
            >
              {overlayType === "forced" ? "Forced" : "Simple"}
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Stack>
  );
}
